import axios from 'axios'

axios.defaults.baseURL = "http://www.weaiove.com";


export const apiGetHomeData = () => axios.get('/home.php/index') //首页轮播图、新闻列表接口

export const apiGetDevelopment = () => axios.get('/home.php/course') //发展历程数据接口

export const apiGetDevelop = () => axios.get('home.php/develop')  //品牌荣誉接口

export const apiGetArrlist = (params) => axios.get('home.php/arrlist?' + params)  //地产开发

export const apiGetNews = () => axios.get('/home.php/newlist') //集团新闻列表数据接口

export const apiGetNewsDetails = (id) => axios.get('/home.php/category?id=' + id)  //集团新闻 + 媒体报道详情页接口

export const apiGetSearch = (content) => axios.get('home.php/newseach?seach=' + content)  //关键词查询数据接口

export const apiGetCate = (content) => axios.get('home.php/newcate?year=' + content) //按年份检索新闻接口

export const apiGetMedia = () => axios.get('/home.php/medialist') //媒体报道

export const apiGetVideos = () => axios.get('home.php/videolist') //品牌影像接口

export const apiGetPaintings = () => axios.get('home.php/painting') //品牌画册接口

export const apiGetCities = () => axios.get('home.php/relation') //联系我们-城市坐标接口--页面有个地图，我用图片代替了

export const apiGetOffers = () => axios.get('home.php/coffer?type=2&seach=') //招聘列表信息接口

export const apiGetOfferDetails = (id) => axios.get('home.php/offerseach?id=' + id)  //招聘信息详情页接口

export const apiGetOfferSearch = (type, search) => axios.get('home.php/coffer?type=' + type + '&seach=' + search) //职业关键词查询接口

export const apiGetQrcode = () => axios.get('home.php/qrcode') //社交媒体城市数据接口

export const apiGetQrcodeById = (id) => axios.get('home.php/qrcode?area=' + id) //项目名微信及二维码接口


export const apiGetStafflist = () => axios.get('home.php/stafflist')  //员工风采
// 集团新闻（没有用到）
// apiGetSearch //关键词查询数据接口
// apiGetCate //按年份检索新闻接口
// 媒体报道（api里没有写）
// 媒体报道新闻列表及年份列表接口  http://love.lanchuangclub.com/home.php/medialist
// 媒体报道关键词查询数据接口 http://love.lanchuangclub.com/home.php/mediaseach
// 按年份检索新闻接口  http://love.lanchuangclub.com/home.php/mediacate